export type TutorialStep =
  | 'move'
  | 'pickup'
  | 'office'
  | 'compliance'
  | 'wrench'
  | 'cashout';

export interface TutorialStepInfo {
  step: TutorialStep;
  index: number;
  total: number;
  text: string;
}

const TOTAL = 6;

export const TUTORIAL_ORDER: TutorialStep[] = [
  'move',
  'pickup',
  'office',
  'compliance',
  'wrench',
  'cashout'
];

export const TUTORIAL_STEPS: Record<TutorialStep, TutorialStepInfo> = {
  move: {
    step: 'move',
    index: 1,
    total: TOTAL,
    text: 'Move around with arrow keys, WASD, or the on-screen D-pad.'
  },
  pickup: {
    step: 'pickup',
    index: 2,
    total: TOTAL,
    text: 'Walk over the orange FILE card to pick it up.'
  },
  office: {
    step: 'office',
    index: 3,
    total: TOTAL,
    text: 'Drop the work at the highlighted OFFICE desk to start a billing entry (TBE).'
  },
  compliance: {
    step: 'compliance',
    index: 4,
    total: TOTAL,
    text: 'Take the TBE entry to the highlighted COMPLIANCE desk for review.'
  },
  wrench: {
    step: 'wrench',
    index: 5,
    total: TOTAL,
    text: 'Rejected! Find the wrench on the map and pick it up to fix the entry.'
  },
  cashout: {
    step: 'cashout',
    index: 6,
    total: TOTAL,
    text: 'Bring the approved entry to the highlighted CASH OUT desk to get paid.'
  }
};

const STORAGE_KEY = 'w2c.tutorialCompleted';

export function tutorialCompleted(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function markTutorialCompleted(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // ignore — private mode or storage disabled
  }
}
